import styled from 'styled-components'

export const RadioContainer = styled.div`
  margin: 20px 0;
`
